export default "<div class=\"evisioEmailEditor\">\n    <div data-dojo-attach-point=\"formContainer\" class=\"evisioEmailEditor-formContainer\"></div>\n</div>\n"